module.exports = __webpack_public_path__ + "static/media/wangtaowei.5fe92d6b.png";